import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from './api.service.abstract';
import { ProductRoomTranslation } from '@pulpo/pulpo-models';

@Injectable({ providedIn: 'root' })
export class ProductRoomTranslationService extends ApiService<ProductRoomTranslation> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/product-room-translations');
  }

  findForProductRoom(
    productRoomId: number
  ): Observable<HttpResponse<ProductRoomTranslation[]>> {
    return this.http.get<ProductRoomTranslation[]>(
      `${this.url}/${this.endpoint}/product-room?productRoomId=${productRoomId}`,
      { observe: 'response' }
    );
  }

  findByProductRoomAndLanguage(
    productRoomId: number,
    language: string
  ): Observable<HttpResponse<ProductRoomTranslation>> {
    return this.http.get<ProductRoomTranslation>(
      `${this.url}/${this.endpoint}/product-room/${productRoomId}/language/${language}`,
      { observe: 'response' }
    );
  }
}
